import { render, staticRenderFns } from "./ClassAssignmentEdit.vue?vue&type=template&id=2ee0e5e6&scoped=true&"
import script from "./ClassAssignmentEdit.vue?vue&type=script&lang=js&"
export * from "./ClassAssignmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee0e5e6",
  null
  
)

export default component.exports